import { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useImpersonation } from '../model/useImpersonation';
import { getImpersonationToken, readImpersonationKind } from '../model/storage';

export function ImpersonationBanner() {
  const { isImpersonating, clientName, exit } = useImpersonation();
  const [exiting, setExiting] = useState(false);

  if (!isImpersonating) return null;

  const token = getImpersonationToken();
  const kind = token ? readImpersonationKind(token) : null;
  // 'support' = ТП. 'partner' = legacy partner→client (no suffix to keep
  // existing UX unchanged). null = malformed token; fall back to no suffix.
  const suffix = kind === 'support' ? ' (ТП)' : '';

  const handleExit = async () => {
    setExiting(true);
    try {
      await exit();
    } finally {
      // exit() reloads the page, so this branch should be unreachable in
      // practice. Reset state defensively in case the reload is blocked.
      setExiting(false);
    }
  };

  return (
    <Box
      data-testid="impersonation-banner"
      sx={{
        position: 'fixed',
        bottom: { xs: 12, sm: 16 },
        left: { xs: 12, sm: 96 },
        zIndex: 1300,
        boxSizing: 'border-box',
        width: { xs: 'calc(100vw - 24px)', sm: 360 },
        maxWidth: { sm: 'calc(100vw - 112px)' },
        bgcolor: 'background.paper',
        color: 'text.primary',
        border: '1px solid',
        borderColor: 'warning.main',
        borderLeft: '4px solid',
        borderLeftColor: 'warning.main',
        borderRadius: '8px',
        boxShadow: '0 8px 24px rgba(28, 29, 34, 0.16)',
        px: 1.5,
        py: 1,
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
      }}
    >
      <Box sx={{ minWidth: 0, flexGrow: 1 }}>
        <Typography
          variant="caption"
          sx={{
            display: 'block',
            color: 'warning.main',
            fontWeight: 700,
            lineHeight: 1.15,
          }}
        >
          Кабинет клиента{suffix}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            lineHeight: 1.25,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {clientName || 'Режим управления активен'}
        </Typography>
      </Box>
      <Button
        size="small"
        variant="contained"
        color="warning"
        onClick={handleExit}
        disabled={exiting}
        sx={{
          flexShrink: 0,
          minWidth: 64,
          px: 1.5,
          py: 0.5,
          color: 'common.white',
          boxShadow: 'none',
        }}
      >
        {exiting ? 'Выходим…' : 'Выйти'}
      </Button>
    </Box>
  );
}
